@keyframes fadeInMoveDown {
    from {
      transform: translateY(-20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  /* Keyframes for fade out and move up */
  @keyframes fadeOutMoveUp {
    from {
      transform: translateY(0);
      opacity: 1;
    }
    to {
      transform: translateY(-20px);
      opacity: 0;
    }
  }
  
  /* Hidden state, setting it off-screen upwards with transparency */
  .hidden-section {
    opacity: 0;
    transform: translateY(-20px);
    transition: transform 0.5s ease-in, opacity 0.5s ease-in;
  }
  
  /* Class applied when div becomes visible */
  .visible-section {
    animation: fadeInMoveDown 1s forwards;
  }
